export default __webpack_public_path__ + "static/media/no-image-placeholder.4dbb1a2f.svg";